// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Response from POST /keys/bulk. On transaction rollback every counter
 * is zero and `errors` describes the failure.
 */
export class BulkKeyResponse implements flatbuffers.IUnpackableObject<BulkKeyResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BulkKeyResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBulkKeyResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: BulkKeyResponse,
  ): BulkKeyResponse {
    return (obj || new BulkKeyResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBulkKeyResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: BulkKeyResponse,
  ): BulkKeyResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BulkKeyResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Server-assigned UUIDs of the newly created keys, in the same
   * order as BulkKeyRequest.create. Empty on rollback.
   */
  createdIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  createdIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Number of keys successfully updated. Zero on rollback.
   */
  updatedCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Number of keys successfully deleted. Zero on rollback.
   */
  deletedCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Empty on success. Populated with free-text error messages on
   * failure. Length > 0 always implies a full rollback.
   */
  errors(index: number): string;
  errors(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  errors(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  errorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startBulkKeyResponse(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addCreatedIds(builder: flatbuffers.Builder, createdIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, createdIdsOffset, 0);
  }

  static createCreatedIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCreatedIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addUpdatedCount(builder: flatbuffers.Builder, updatedCount: number) {
    builder.addFieldInt32(1, updatedCount, 0);
  }

  static addDeletedCount(builder: flatbuffers.Builder, deletedCount: number) {
    builder.addFieldInt32(2, deletedCount, 0);
  }

  static addErrors(builder: flatbuffers.Builder, errorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, errorsOffset, 0);
  }

  static createErrorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startErrorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endBulkKeyResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createBulkKeyResponse(
    builder: flatbuffers.Builder,
    createdIdsOffset: flatbuffers.Offset,
    updatedCount: number,
    deletedCount: number,
    errorsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    BulkKeyResponse.startBulkKeyResponse(builder);
    BulkKeyResponse.addCreatedIds(builder, createdIdsOffset);
    BulkKeyResponse.addUpdatedCount(builder, updatedCount);
    BulkKeyResponse.addDeletedCount(builder, deletedCount);
    BulkKeyResponse.addErrors(builder, errorsOffset);
    return BulkKeyResponse.endBulkKeyResponse(builder);
  }

  unpack(): BulkKeyResponseT {
    return new BulkKeyResponseT(
      this.bb!.createObjList<Uuid, UuidT>(this.createdIds.bind(this), this.createdIdsLength()),
      this.updatedCount(),
      this.deletedCount(),
      this.bb!.createScalarList<string>(this.errors.bind(this), this.errorsLength()),
    );
  }

  unpackTo(_o: BulkKeyResponseT): void {
    _o.createdIds = this.bb!.createObjList<Uuid, UuidT>(
      this.createdIds.bind(this),
      this.createdIdsLength(),
    );
    _o.updatedCount = this.updatedCount();
    _o.deletedCount = this.deletedCount();
    _o.errors = this.bb!.createScalarList<string>(this.errors.bind(this), this.errorsLength());
  }

  unpackFields(...fields: string[]): BulkKeyResponseT {
    const t = new BulkKeyResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("created_ids")) {
      t.createdIds = this.bb!.createObjList<Uuid, UuidT>(
        this.createdIds.bind(this),
        this.createdIdsLength(),
      );
    }
    if (fieldSet.has("updated_count")) {
      t.updatedCount = this.updatedCount();
    }
    if (fieldSet.has("deleted_count")) {
      t.deletedCount = this.deletedCount();
    }
    if (fieldSet.has("errors")) {
      t.errors = this.bb!.createScalarList<string>(this.errors.bind(this), this.errorsLength());
    }
    return t;
  }
}

export class BulkKeyResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public createdIds: UuidT[] = [],
    public updatedCount: number = 0,
    public deletedCount: number = 0,
    public errors: string[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const createdIds = BulkKeyResponse.createCreatedIdsVector(
      builder,
      builder.createObjectOffsetList(this.createdIds),
    );
    const errors = BulkKeyResponse.createErrorsVector(
      builder,
      builder.createObjectOffsetList(this.errors),
    );

    return BulkKeyResponse.createBulkKeyResponse(
      builder,
      createdIds,
      this.updatedCount,
      this.deletedCount,
      errors,
    );
  }

  clone(): BulkKeyResponseT {
    const obj = new BulkKeyResponseT();
    obj.createdIds = this.createdIds.map((e) => e.clone());
    obj.updatedCount = this.updatedCount;
    obj.deletedCount = this.deletedCount;
    obj.errors = [...this.errors];
    return obj;
  }

  equals(other: BulkKeyResponseT): boolean {
    if (this.createdIds.length !== other.createdIds.length) return false;
    for (let i = 0; i < this.createdIds.length; i++) {
      const a = this.createdIds[i];
      const b = other.createdIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.updatedCount !== other.updatedCount) return false;
    if (this.deletedCount !== other.deletedCount) return false;
    if (this.errors.length !== other.errors.length) return false;
    for (let i = 0; i < this.errors.length; i++) {
      if (this.errors[i] !== other.errors[i]) return false;
    }
    return true;
  }
}

export function verifyBulkKeyResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
  } finally {
    verifier.popDepth();
  }
}
